<template>
    <div class="login-page">
        <div class="login-container">
            <!-- 背景图片 -->
            <div class="background-image" :style="{ backgroundImage: `url(${loginBgPath})` }"></div>
            <!-- 中央内容面板 -->
            <div class="login-content">
                <!-- 投标人登录 -->
                <div class="role-bg" @click="handleLogin('bidder')">
                    <img :src="tbImgPath" />
                    <div class="role-bg-text">
                        {{ roleLoginTexts.bidder }}
                    </div>
                </div>
                <!-- 招标人登录 -->
                <div class="role-bg" @click="handleLogin('tenderee')">
                    <img :src="zbImgPath" />
                    <div class="role-bg-text">
                        {{ roleLoginTexts.tenderee }}
                    </div>
                </div>
                <!-- 招标代理登录 -->
                <div class="role-bg" @click="handleLogin('agent')">
                    <img :src="dlImgPath" />
                    <div class="role-bg-text">
                        {{ roleLoginTexts.agent }}
                    </div>
                </div>
                <!-- 评标系统 -->
                <div class="role-bg" @click="handleLogin('evaluation')">
                    <img :src="zjImgPath" />
                    <div class="role-bg-text">
                        {{ roleLoginTexts.evaluation }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { XTXASynObject } from '@/api/ca/XTXASynObject'
export default {
    name: 'LoginPage',
    computed: {
        loginBgPath() {
            return this.$channelMaterial.getLoginBgPath()
        },
        // 投标人图片
        tbImgPath() {
            return this.$channelMaterial.tbLoginImg()
        },
        // 招标人图片
        zbImgPath() {
            return this.$channelMaterial.zbLoginImg()
        },
        // 招标代理图片
        dlImgPath() {
            return this.$channelMaterial.dLLoginImg()
        },
        zjImgPath() {
            return this.$channelMaterial.zjLoginImg()
        },
        roleLoginTexts() {
            return this.$channelMaterial.getRoleLoginTexts()
        },

    },

    mounted() {
    },
    methods: {
        handleLogin(type) {
            // 清除本地存储
            localStorage.clear()
            // 评标系统特殊处理
            if (type === 'evaluation') {
                window.open('/todayEvaluation', '_blank')
                return
            }
            // 获取对应的token
            const tokenKey = `token_${type}`
            const existingToken = Cookies.get(tokenKey)
            if (existingToken) {
                // 设置当前token
                Cookies.set('token', existingToken)
                // 路由映射配置
                const routeMap = {
                    'agent': '/agentHome',
                    'tenderee': '/agentHome',
                    'bidder': '/bidderHome',
                    'expert': '/expertHome'
                }
                console.log(tokenKey);

                //跳转到对应页面
                const targetRoute = routeMap[type] || '/home'
                this.$router.push(targetRoute)
            } else {
                // 无token时跳转到登录页
                window.open(`/useLogin?type=${type}`, '_blank')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.login-page {
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;

    .login-container {
        width: 100%;
        min-height: 100vh;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    // 背景图片
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }



    // 中央内容区域
    .login-content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 200px;
        z-index: 10;
        gap: 20px;

        .role-bg {
   // height: auto;
            // width: 355px; // 廊坊 

            width: 285px;
         
            height: 409px;
            position: relative;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-10px);
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
            }

            img {
                width: 100%;
                height: 100%;
                transition: transform 0.3s ease;
            }

            .role-bg-text {
                position: absolute;
                bottom: 51px;
                font-family: PingFang SC, PingFang SC;
                left: 0;
                right: 0;
                text-align: center;
                font-weight: 400;
                font-size: 24px;
                color: #000000;
                transition: color 0.3s ease;
            }
        }
    }

}
</style>